'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _drgs = require('./drgs.component');

var _drgs2 = _interopRequireDefault(_drgs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var drgsModule = _angular2.default.module('drgs', [_angularUiRouter2.default]).component('drgs', _drgs2.default);

exports.default = drgsModule;


// WEBPACK FOOTER //
// ./client/app/common/admin/drgs/drgs.js